<template>
  <Modal :open="props.open" @close-modal="$emit('close-modal')" custom-height="h-auto max-h-[80vh]">
    <template #modal-header>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="BadgeDollarSign" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">Phoenix Flex</p>
        </div>
        <h3 class="font-semibold text-[28px] text-strongest">Phoenix Flex Notice Window</h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6">
        <Table
          :table_headers="s1_table_headers"
          :table_data="investments"
          variant="secondary"
          :has_actions="true"
          :fields_with_custom_styles="['offering_type', 'amount']"
          mobile_primary_field="amount"
          :column_gap_px="85"
        >
          <template v-slot:offering_type="entry">
            <div>
              <p class="font-medium">{{ entry.row.offering_type }} offering</p>
            </div>
          </template>
          <template v-slot:amount="entry">
            <div>
              <p class="font-semibold text-success">
                {{ formatCurrency(entry.row.amount) }}
              </p>
            </div>
          </template>
          <template v-slot:actions="entry">
            <div class="flex items-center gap-2">
              <!-- <Button variant="primary-grey" @click="handleSelectOptOut(entry.row)">
                <template #label> Opt Out</template>
              </Button> -->
              <Button
                variant="primary-grey"
                @click="router.push(`/investment-details?recordId=${entry.row.record_id}`)"
              >
                <template #label> Make Decision </template>
              </Button>
            </div>
          </template>
        </Table>
      </div>
    </template>
    <template #footer>
      <Button @click="$emit('close-modal')" variant="primary-secondary">
        <template #label> Cancel </template>
      </Button>
    </template>
  </Modal>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useDataStore } from "@/stores";
import { Modal, Icon, Table, Button, DetailBanner, AsteriskNotice } from "@/components";

const router = useRouter();
const dataStore = useDataStore();

let s1_table_headers = [
  {
    label: "Amount",
    field_name: "amount",
    field_type: "number",
    number_type: "currency",
  },
  { label: "Type", field_name: "type" },
  { label: "Status", field_name: "status" },
];

const emit = defineEmits(["close-modal"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  investments: { type: Array, required: true },
});

async function handleSelectOptOut(row) {
  emit("close-modal");
  emit("generate-signing-link", row.record_id);
}

function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
</script>
